'use strict';
import angular from 'angular';

angular.module('core.service.directives');